import {CustomModal, CustomModalProps} from "../reusable/Modals/CustomModal";
import IngredientsForm from "./IngredientsForm";
import {IngredientModel} from "../logic/models/IngredientModel";

type IngredientsModalProps = CustomModalProps & {
    mode: 'edit' | 'add'
    ingredient?: IngredientModel,
    onCancel?: () => void
}

export function IngredientsModal(props: IngredientsModalProps) {
    return (
        <CustomModal render={props.render} onOuterClick={props.onOuterClick}>
            <IngredientsForm mode={props.mode} ingredient={props.ingredient} onCancel={props.onCancel}/>
        </CustomModal>
    )
}
